import React from "react";
import { useModal } from "../../context/ModalContext";
import Image from "../Image";
import Button from "../Button";

import "../../assets/styles/components/modals/ModalAnamnesisRenew.css";

const ModalAnamneseUpgradeV2 = ({ data }) => {
  const { closeModal } = useModal();

  const handleConfirm = () => {
    try {
      if (typeof data?.onConfirm === "function") {
        data.onConfirm();
      }
    } catch (e) {
      console.error("Erro no callback onConfirm do modal de upgrade de anamnese:", e);
    }
    closeModal();
  };

  return (
    <div className="ModalAnamnesisRenew" style={{ backgroundColor: "#E6DDCE" }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-auto">
            <Image image="trio-anamnese.png" />
          </div>
        </div>
        <div className="row justify-content-center align-items-center">
          <div className="col-12 col-lg-11 text-center">
            <h3 className="m-0">
              <strong>A Puríssima evoluiu.</strong>
            </h3>
            <p className="my-3 my-lg-4">
              Agora a sua suplementação cabe em{" "}
              <strong>um único shake por dia, em vez de dois</strong>: mais simples de
              tomar, com a mesma fórmula completa e personalizada para você.
            </p>
            <p className="mb-3 mb-lg-4">
              E para acompanhar essa evolução, também{" "}
              <strong>atualizamos a anamnese</strong>, para deixar a sua prescrição
              ainda mais precisa e eficaz.
            </p>
            <p className="mb-0">
              Atualize sua anamnese agora para <strong>receber a sua fórmula na nova versão.</strong>
            </p>

            <div className="box-content mt-4">
              <div className="row justify-content-center brandon">
                <div className="col-lg-10 px-0">
                  <Button
                    label="RESPONDER NOVA ANAMNESE"
                    classes="w-100"
                    onClick={handleConfirm}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAnamneseUpgradeV2;
